// FAQ accordion — accessible, no animation library needed
function initFaq(section) {
  if (section.dataset.faqBound) return;
  section.dataset.faqBound = "true";

  section.querySelectorAll("[data-faq-item]").forEach((item) => {
    const btn    = item.querySelector(".faq-question");
    const panel  = item.querySelector(".faq-answer");
    if (!btn || !panel) return;

    btn.addEventListener("click", () => {
      const isOpen = btn.getAttribute("aria-expanded") === "true";

      // Close all others in this section
      section.querySelectorAll("[data-faq-item]").forEach((it) => {
        const b = it.querySelector(".faq-question");
        const p = b && document.getElementById(b.getAttribute("aria-controls"));
        if (b) b.setAttribute("aria-expanded", "false");
        if (p) p.hidden = true;
        it.removeAttribute("data-faq-open");
      });

      // Toggle clicked
      if (!isOpen) {
        btn.setAttribute("aria-expanded", "true");
        panel.hidden = false;
        item.setAttribute("data-faq-open", "");
      }
    });
  });
}

function initAllFaqs() {
  document.querySelectorAll(".faq-section").forEach(initFaq);
}

document.addEventListener("turbo:load", initAllFaqs);
if (document.readyState !== "loading") initAllFaqs();
